export const getColorFromEntity = (colorEntity = {}) => {
  return colorEntity?.custom_color
    ? colorEntity.custom_color
    : colorEntity?.default_color
    ? colorEntity.default_color
    : null
}
